<!-- <div class="" *ngFor="let item of messageList | groupBy:'day'">
<div class="column has-text-centered timing" *ngIf="item && item.key !== 'undefined' && item.key">
  <small>{{item.key}}</small>
</div>
</div> -->

@for (message of messageList; track trackByFn(i, message); let i = $index) {
<div class="">
  @if (message?.showDay) {
  <div class="column has-text-centered timing">
    <small>{{ message.day }}</small>
  </div>
  }
  <div class="chat-file-type" #scrollframe>
    <article class="media">
      <figure class="media-left">
        <p class="image">
          @if (!message.user_icon) {
          <empty-uname
            [userName]="message.first_name"
            [detailHeadProfile]="true"
          ></empty-uname>
          } @if (message.user_icon) {
          <img [src]="profileUrl + message.user_icon" />
          }
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <div class="msg-content file-links" (mouseenter)="messageFocus(i)">
            <strong>{{ message.first_name + " " + message.last_name }}</strong>
            @if (loggedUserId === message.from_user_id) {
            <span class="message-update">
              @if (!message.is_delivered && !message.is_read) {
              <span
                class="read-receipt-block"
                data-title="Sent"
                aria-label="Sent"
              >
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
              } @if (message.is_delivered || message.is_read) {
              <span class="">
                @if (message.is_read) {
                <span>
                  <span
                    class="read-receipt-block"
                    data-title="Seen"
                    aria-label="Seen"
                  >
                    <i
                      class="fa fa-check"
                      aria-hidden="true"
                      [ngClass]="{ read: message.is_read }"
                    ></i>
                    <i
                      class="fa fa-check"
                      aria-hidden="true"
                      [ngClass]="{ read: message.is_read }"
                    ></i>
                  </span>
                </span>
                } @else {
                <span
                  class="read-receipt-block"
                  data-title="Delivered"
                  aria-label="Delivered"
                >
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <i class="fa fa-check" aria-hidden="true"></i>
                </span>
                }
              </span>
              }
            </span>
            } @if (loggedUserId === message.from_user_id && isShowing[i]) {
            <span
              class="dropdown message-reply"
              [ngClass]="{ 'is-active': isActive[i] }"
              (click)="moreOptionMenu(i)"
            >
              <div class="dropdown-trigger">
                <a
                  aria-haspopup="true"
                  aria-controls="dropdown-menu3"
                  data-title="More options"
                >
                  <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                </a>
              </div>
            </span>
            }
            <br />
            @if (message.message_type === 'chat') {
            <span
              [ngClass]="{ 'show-less': !isCollapsed[i] }"
              [class.collapsed]="isCollapsed[i]"
              id="scrollFrame_{{ i }}"
              class="msgShowListView scrollFrame_{{ i }}"
              [innerHTML]="
                message.message
                  | highlight : search
                  | linkify
                  | limitTo : isCollapsed[i]
                  | emojismart
              "
            ></span>
            } @if (message.message.length > maxLength) {
            <span>
              <a class="msgShowHide" (click)="aftershowMoreToggle(i)"
                >Show {{ !isCollapsed[i] ? "More" : "less" }}</a
              >
            </span>
            } @if (message.message_type === 'file') {
            <span>
              @if (message.message_type === 'file') {
              <app-secured-image
                [src]="message.thumb_file_path"
                [classStyle]="'abc'"
                [fileData]="message"
              ></app-secured-image>
              }
            </span>
            }
          </div>
        </div>
      </div>
      <div class="">
        <small class="text-clr-grey is-size-7 small-text-time">{{
          message.createdAt | date : "shortTime"
        }}</small>
      </div>
    </article>
  </div>
</div>
}
<!-- <div class="showAssignment">
    <div class="modal " [ngClass]="{'is-modal-active': activePinTask[message.message_id] == true}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <form name="form" (ngSubmit)="f.form.valid && submittedTask(message)" #f="ngForm" novalidate>
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                New Assignment
              </p>
              <button class="delete" aria-label="close" #onClose (click)="cancelTaskPin(message.message_id)"></button>
            </header>
            <div class="card-content">
              <div class="content">
                <div class="field">
                  <div class="content">
                    <label for="" class="label">Task</label>
                    <span class="file-name-list" [innerHTML]="message.message"></span>
                  </div>
                </div>
                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class="field">
                      <div class="content">
                        <label class="label">Assigned By</label>
                        <span>{{message.first_name}}</span>
                      </div>
                    </div>
                    <div class="field" >
                      <div class="content">
                        <label for="" class="label">Assigned To</label>
                        <div class="" *ngIf="loggedUserId != message.from_user_id && !message.group_id; else elseTemplate">
                          <span>{{message.first_name}}</span>
                        </div>
                        <ng-template  #elseTemplate>
                          <span *ngIf="message.group_id">Group</span>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class="field">
                      <div class="content">
                        <label for="" class="label">Assignment Due Date</label>
                        <input class="input datepicker maxDateToday hasDatepicker" [ngClass]="{ 'is-invalid': f.submitted && due_date.invalid }"  type="date" name="due_date" [(ngModel)]="model.due_date" #due_date="ngModel" required>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer class="card-footer is-right">
              <div class="control is-pulled-right move-right">
                <button class="button taskSubmit is-info " [disabled]="f.form.invalid">Submit Task</button>
                <button class="button taskSubmit"  (click)="cancelTaskPin(message.message_id)">Cancel</button>
              </div>
            </footer>
          </div>
        </form>
      </div>
    </div>
  </div> -->
